import script from "./noRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./noRecord.vue?vue&type=script&setup=true&lang=js"

import "./noRecord.vue?vue&type=style&index=0&id=1d9568c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9568c2"]])

export default __exports__